<template>
  <div>
    <default-card>
      <template slot="title-left"> Movimentações Financeiras 💸 </template>
      <template slot="title-right">
        <v-btn @click="addExpense()" text small
          class="btn-primary"
          :disabled="loading"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          Adicionar
        </v-btn>
      </template>
      <template slot="content">
        <card-loading-transparent v-if="loading"></card-loading-transparent>
        <div v-if="!loading" class="mt-4 pb-6">
          <div v-if="!has_any_expense" class="subtitle-activity mt-4 ml-3 mb-n5" style="color:dimgrey">Esse evento ainda não contem gastos!</div>
          <v-row v-if="has_any_expense" class="d-flex justify-center">
            <v-col v-for="expense in expenses" :key="expense.id" cols="12" md="11" class="mt-2">
              <div class="d-flex">
                <div :class="expense.kind == 'income' ? 'pa-2 btn-success' : 'pa-2 btn-error'">
                  <span style="font-size: x-large;">💸</span>
                </div>
                <div class="d-flex justify-space-between" style="width: 100%;">
                  <v-row class="d-block justify-start ml-1">
                    <v-col cols="12" class="d-flex justify-start">
                      <span class="mr-1 caption" v-if="expense.category">{{category_map[expense.category]}} | </span>
                      <span class="caption" style="color: black!important;">
                        {{expense.name}}
                      </span>
                    </v-col>
                    <v-col cols="12" class="mt-n9 d-flex justify-start">
                      <span class="subtitle-activity">{{parseFloat(expense.value/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</span>
                    </v-col>
                  </v-row>
                  <div class="mr-n2">
                    <v-btn class="btn-success" icon tile text small @click="editMovement(expense)">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn class="btn-success ml-1" icon tile text small @click="deleteMovement(expense)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="11" class="mt-10">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" md="11">
              <div class="my-n2 d-flex justify-space-between">
                <div>
                  GASTOS TOTAIS:
                </div>
                <div>
                  <span class="ml-1" :style="normal">{{total_expenses.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</span>
                </div>
              </div>
              <div class="mb-n2 mt-2 d-flex justify-space-between">
                <div>
                  SALDO:
                </div>
                <div>
                  <span class="ml-1" :style="balance_expenses < 0 ? error : success">{{balance_expenses > 0 ? '+' :''}} {{balance_expenses.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </template>
      <template slot="actions"> </template>
    </default-card>

    <v-dialog v-if="!loading" v-model="dialog_movement" max-width="700px">
      <v-card style="overflow: hidden">
        <v-card-title primary-title class='white white--text justify-center pt-2 mb-n6 px-2'>
          <span class="title-card ml-3">{{editing_movement ? 'Editar movimentação' : 'Adicionar movimentação'}}</span>
          <v-spacer></v-spacer>
          <v-btn class="mr-2 mt-1" @click="dialog_movement = false" icon x-small color="primary" style="background-color: var(--v-primary-base);">
            <v-icon color="white" small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text align="center" class="mt-4 pb-6">
          <form-register-movement v-if="dialog_movement" @movementCreated="movementCreated" :show_title="false" 
            :movement_to_edit="editing_movement ? movement_to_edit : null" 
            :create_event_movement="!editing_movement" 
            :editing_movement="editing_movement" 
            is_component_used_to_create_an_expense
            @done="movementCreated"
          > </form-register-movement>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from "@/mixins/validations";

  export default {
    name: 'EventExpensesCard',
    mixins: [ validations ],
    props: {
    },
    components: {
      FormRegisterMovement: () => import ('../../../financial/register/forms/FormRegisterMovement.vue'),
      DialogShowMovement: () => import('../../../financial/shared/DialogShowMovement.vue'),
    },
    data() {
      return {
        error: 'font-weight: bold;text-transform: uppercase; color: red',
        success: 'font-weight: bold;text-transform: uppercase; color: green',
        normal: 'font-weight: bold;text-transform: uppercase; color: black',
        expenses: [],
        dialog_movement: false,
        loading: false,
        movement_to_edit: {},
        editing_movement: false,
        category_map: {
          food: 'Alimentação',
          transport: 'Transporte',
          marketing: 'Marketing',
          investment: 'Investimento',
          taxes: 'Impostos',
          operational: 'Operacionais',
          bonus: 'Bonificação',
          other: 'Outro',
        },
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      addExpense(){
        this.movement_to_edit = {}
        this.editing_movement = false
        this.dialog_movement = true
      },
      deleteMovement(mov){
        this.$swal({
          showConfirmButton: true,
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          title: `Deseja excluir essa movimentação?`,
          icon: 'question',
        }).then(r=>{
          if (r.isConfirmed) {
            Api.Movement.delete(mov.id).then((r)=>{
  
            }).catch((err)=>{
              console.log(err)
            }).finally(()=>{
              this.getData()
            })
          }
        });
      },
      editMovement(mov){
        this.movement_to_edit = mov
        this.editing_movement = true
        this.dialog_movement = true
      },
      movementCreated(){
        this.movement_to_edit = {}
        this.editing_movement = false
        this.dialog_movement = false
        this.getData()
      },
      getData(){
        this.loading = true
        let event_id = this.$route.params.id
        Api.EventExpense.index(event_id).then((r)=>{
          this.expenses = [...r.data]
          setTimeout(()=>{
            this.loading = false
          },600)
        })
      },
      ...mapActions({
        addNotification: 'Notification/add'
      })
    },
    computed: {
      total_expenses(){
        let total = this.expenses.filter(({kind})=> kind == 'outcome').reduce((acc, one) => acc + parseFloat((one.value.toString()).replace(/,/g, '')) , 0)
        
        return parseFloat(total/100)
      },
      balance_expenses(){
        let outcome = this.expenses.filter(({kind})=> kind == 'outcome').reduce((acc, one) => acc + parseFloat((one.value.toString()).replace(/,/g, '')) , 0)
        let income = this.expenses.filter(({kind})=> kind == 'income').reduce((acc, one) => acc + parseFloat((one.value.toString()).replace(/,/g, '')) , 0)
        
        let balance = income - outcome

        return parseFloat(balance/100)
      },
      has_any_expense(){
        return Object.keys(this.expenses).length > 0
      }
    },

  }
</script>

<style lang="scss" scoped>

</style>